import bookOpen from "../../assets/landingPageItems/bookOpen.svg";
import usersIcon from "../../assets/landingPageItems/users.svg";
import bolt from "../../assets/landingPageItems/bolt.svg";
import shield from "../../assets/landingPageItems/shield.svg";
import check from "../../assets/landingPageItems/check.svg";

export default function WhoWeServe() {
  const users = [
    {
      title: "Bookkeepers & Accountants",
      description: "Streamline Client Data Processing And Reduce Manual Work",
      icon: bookOpen,
    },
    {
      title: "Online Sellers",
      description: "Manage Orders From Multiple Channels Effortlessly",
      icon: usersIcon,
    },
    {
      title: "Operations Teams",
      description: "Handle Multi-Channel Sales Data With Ease",
      icon: bolt,
    },
    {
      title: "SMBs With Multiple Platforms",
      description: "Shopify · Square · Stripe Setups Made Simple",
      icon: check,
    },
    {
      title: "Multi-Location Retailers",
      description: "Consolidate Data From Various POS Systems",
      icon: shield,
    },
  ];

  return (
    <section className="bg-lightBlue text-white py-8 md:py-12 font-raleway">
      <div className=" mx-auto text-center">
        <h2 className="text-4xl md:text-6xl font-audiowide text-white">
          Who We <span className="text-lightGreen">Serve</span>
        </h2>
        <p className="mt-4 md:mt-5 text-base md:text-lg text-gray-300">
          Built For Professionals Who Value Efficiency
        </p>
        <div className="mt-12 flex flex-wrap justify-center gap-4">
          {users.map((item, idx) => (
            <div
              key={idx}
              className="w-full lg:w-[calc(33.333%-1rem)] max-w-[650px] border border-lightGreen rounded-xl p-6 bg-white bg-opacity-5 transition text-start"
            >
              <img
                src={item.icon}
                alt={item.title}
                className="h-[60px] select-none"
                draggable="false"
              />
              <h3 className="text-base md:text-lg font-semibold mb-1">
                {item.title}
              </h3>
              <p className="text-sm md:text-base text-gray-300">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
